var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBillPayment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.834 20.5C24.2481 20.5 24.5933 20.8408 24.4912 21.2422C24.1608 22.54 22.9846 23.5 21.584 23.5H12.584C13.9846 23.5 15.1608 22.54 15.4912 21.2422C15.5934 20.8408 15.9198 20.5 16.334 20.5H23.834ZM18.584 8.5C20.2408 8.5 21.584 9.84315 21.584 11.5V19.375H15.0586C14.7275 19.3752 14.4592 19.6435 14.459 19.9746C14.459 21.3001 13.3655 22.375 12.04 22.375C10.694 22.3748 9.58398 21.2836 9.58398 19.9375V11.5C9.58398 9.84315 10.9271 8.5 12.584 8.5H18.584ZM12.584 15.4375C12.2733 15.4375 12.0215 15.6893 12.0215 16C12.0215 16.3107 12.2733 16.5625 12.584 16.5625H15.584C15.8946 16.5625 16.1465 16.3107 16.1465 16C16.1465 15.6893 15.8946 15.4375 15.584 15.4375H12.584ZM12.584 11.6875C12.2733 11.6875 12.0215 11.9393 12.0215 12.25C12.0215 12.5607 12.2733 12.8125 12.584 12.8125H18.584C18.8946 12.8125 19.1465 12.5607 19.1465 12.25C19.1465 11.9393 18.8946 11.6875 18.584 11.6875H12.584Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBillPayment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bill_payment.9852e04e1992d5d4c62f5bf601b30a36.svg";